var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLinkOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13323",
    "data-name": "Group 13323",
    transform: "translate(-1421 -574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13238",
    "data-name": "Group 13238",
    transform: "translate(1421 574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13245",
    "data-name": "Group 13245",
    transform: "translate(8414 -9994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45471",
    "data-name": "Path 45471",
    d: "M5.64,133.066a2.856,2.856,0,0,1,2.164.669c.269.234.754.738.29,1.038-.4.258-.635-.238-.886-.442a2,2,0,0,0-2.573.054c-1.136.968-2.15,2.28-3.279,3.279A1.99,1.99,0,0,0,4.137,140.5c.719-.6,1.345-1.443,2.07-2.052a.423.423,0,0,1,.49.684c-.963.8-1.854,2.256-3.106,2.594A2.831,2.831,0,0,1,.734,137.1c1-1.145,2.283-2.17,3.306-3.306a2.947,2.947,0,0,1,1.6-.725",
    transform: "translate(-6987.673 10444.839)",
    fill: "#ef7b13",
    stroke: "#ef7b13",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45472",
    "data-name": "Path 45472",
    d: "M152.431.012a2.833,2.833,0,0,1,2.33,4.738c-1,1.135-2.259,2.151-3.279,3.279a2.855,2.855,0,0,1-3.763.082c-.274-.234-.778-.744-.305-1.051.4-.258.635.238.886.442a2.011,2.011,0,0,0,2.4.079c1.077-1.138,2.437-2.23,3.45-3.412a1.99,1.99,0,0,0-2.81-2.81c-.7.6-1.32,1.4-2.023,2.016a.423.423,0,0,1-.535-.645c1.135-.969,2.025-2.573,3.646-2.718",
    transform: "translate(-7129.843 10573.327)",
    fill: "#ef7b13",
    stroke: "#ef7b13",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkOrange);
export default __webpack_public_path__ + "static/media/copy-link-orange.729ac143553fe5ecd193033e7b214a8c.svg";
export { ForwardRef as ReactComponent };